import React from "react";
import { Link } from "react-router-dom";
import heroImg from "../../../images/home-doctor-visit-uganda.jpeg";
import heroFallback from "../../../images/hero1.jpeg";
import PageSEO from "../../SEO/PageSEO";
import "./Main.css";

export default function Main() {
  return (
    <>
      <PageSEO
        title="Home Doctor Visits & Mobile Healthcare"
        description="Yitalife brings qualified doctors to your home, workplace, and community across Uganda. Book a home visit, antenatal care, corporate health check, telemedicine, or community outreach today. A service of Yita Medical Services (YMS)."
        canonical="https://www.yitalife.com/"
      />
      <section
        className="hero-section"
        aria-label="Yitalife - Home Healthcare Uganda"
      >
        {/* Background */}
        <div
          className="hero-bg"
          aria-hidden="true"
          style={{ backgroundImage: `url(${heroImg}), url(${heroFallback})` }}
        ></div>
        <div className="hero-overlay" aria-hidden="true"></div>

        <div className="hero-content w-100">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-xl-7">
                <div className="hero-badge" data-aos="fade-down">
                  <ion-icon name="medical-outline"></ion-icon>
                  Welcome to Yitalife
                </div>

                <h1
                  className="hero-title"
                  data-aos="fade-right"
                  data-aos-delay="100"
                >
                  Mobile Doctors
                  <span className="accent-word">&amp; Outdoor Healthcare</span>
                </h1>

                <p
                  className="hero-subtitle"
                  data-aos="fade-right"
                  data-aos-delay="200"
                >
                  Equitable access to quality healthcare services - delivered to
                  your home, workplace, and remote communities across Uganda.
                </p>

                <p
                  className="hero-tagline"
                  data-aos="fade-right"
                  data-aos-delay="250"
                >
                  Yitalife is a service of{" "}
                  <strong>Yita Medical Services (YMS)</strong>. Part of our
                  income supports humanitarian causes.
                </p>

                <div
                  className="hero-buttons"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <Link to="/Appointment">
                    <button className="hero-btn-primary">
                      Make an Appointment
                    </button>
                  </Link>
                  <Link to="/Services">
                    <button className="hero-btn-outline">Our Services</button>
                  </Link>
                </div>

                {/* Service highlights */}
                <div
                  className="hero-stats"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <div className="hero-stat">
                    <div className="hero-stat-number">
                      25<span>+</span>
                    </div>
                    <div className="hero-stat-label">Medical Professionals</div>
                  </div>
                  <div className="hero-stat">
                    <div className="hero-stat-number">
                      5,000<span>+</span>
                    </div>
                    <div className="hero-stat-label">Patients Served</div>
                  </div>
                  <div className="hero-stat">
                    <div className="hero-stat-number">
                      24<span>/7</span>
                    </div>
                    <div className="hero-stat-label">Emergency Care</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
